import React from 'react';
import { useWindowWidth } from '../../../helper';
import config from '../../../config/config';
import { useTranslation } from '../../../config/TranslationProvider';

function getScrollToPosition(size) {
    const {breakpoints} = config;

    // For bigger screens
    if (size >= breakpoints.lg) {
        return {top: 450, left: 0};
    }

    // For medium sized screens like tablets
    if (size >= breakpoints.sm) {
        return {top: 468, left: 0};
    }

    // For mobile screens
    return {top: 0, left: 0};
}

const ListingActionButton = ({btnType, listType, setListType}) => {
    const [size] = useWindowWidth();

    const handleListChange = () => {
        setListType(btnType);

        // Jump to top when listType is changed to map, ignore if listType already is map
        if (btnType === 'map' && listType !== 'map') {
            window.scrollTo(getScrollToPosition(size));
        }
    };

    const ariaLabel = 'Listenlayout ändern zu ' + useTranslation(`list_layout_${btnType}`);

    return (
        <div className="view-mode">
            <button
                className={'action-btn' + (listType === btnType ? ' active' : '')}
                onClick={handleListChange}
                aria-label={ariaLabel}
                // The map should not be focusable. Navigating the map only via keyboard is not possible in a useful way
                tabIndex={ btnType === 'map' ? '-1' : 'auto'}
            >
                { btnType === 'list' && <span className="la la-list" />}
                { btnType === 'grid' && <span className="la la-th-large" />}
                { btnType === 'map' && <span className="la la-map" />}
            </button>
        </div>
    );
};

export default ListingActionButton;
